import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouse } from "@fortawesome/free-solid-svg-icons";

export const BreadcrumbComponent = ({ nomeOrigem, nomeTipo, idOrigem, idTipo, handleBreadcrumbClick }) => {

  return (
    <div className="mt-3">
      <Breadcrumb>
        <Breadcrumb.Item href="#" active={idOrigem === -1 ? true : false} onClick={() => handleBreadcrumbClick(-1, -1)}><FontAwesomeIcon icon={faHouse} />
        </Breadcrumb.Item>

        {idOrigem !== -1 && (
          <Breadcrumb.Item href="#" active={idTipo === -1 ? true : false} onClick={() => handleBreadcrumbClick(idOrigem, -1)}>
            {nomeOrigem}
          </Breadcrumb.Item>)
        }
        {idTipo !== -1 && (
          <Breadcrumb.Item href="#" active={true} onClick={() => handleBreadcrumbClick(idOrigem, idTipo)}>
            {nomeTipo}
          </Breadcrumb.Item>
        )
        }

      </Breadcrumb>
    </div>
  );
};